import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';

import { App } from './app/App';
import './styles/index.css';

// autoUpdate: when a new release's worker activates, this registration reloads
// the tab once. Without it the worker still updates in the background but the
// open page keeps rendering the previous bundle, so a deploy only appears after
// a second reload. `immediate` registers without waiting for the load event.
registerSW({ immediate: true });

const container = document.getElementById('root');
if (!container) throw new Error('No se encontró el elemento #root en index.html.');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
